import { z } from "zod";
import { zWorkShiftCommonSchema } from "./workShift.common";
export const zWorkShiftSchemaDto = zWorkShiftCommonSchema.extend({
    plannedStartTime: z.string(),
    plannedEndTime: z.string(),
    actualStartTime: z.string().nullable().optional(),
    actualEndTime: z.string().nullable().optional(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const zWorkShiftCreateSchemaDto = zWorkShiftSchemaDto.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
});
